import { MERGEPATCHJSON } from "./constants/specialContentTypes";

const getWarehouseStocks = () => ({
  method: "GET",
  url: `/warehouse_stocks`,
});

const addWarehouseStocks = (data) => ({
  method: "POST",
  url: "/warehouse_stocks",
  data,
});

const updateWarehouseStocks = ({ id, ...data }) => ({
  method: "PATCH",
  url: `/warehouse_stocks/${id}`,
  data,
  headers: { ...MERGEPATCHJSON },
});

const deleteWarehouseStocks = ({ id }) => ({
  method: "DELETE",
  url: `/warehouse_stocks/${id}`,
});

const getWarehouses = () => ({
  method: "GET",
  url: `/warehouses`,
});

const addWarehouse = (data) => ({
  method: "POST",
  url: "/warehouses",
  data,
});

const updateWarehouse = ({ id, ...data }) => ({
  method: "PATCH",
  url: `/warehouses/${id}`,
  data,
  headers: { ...MERGEPATCHJSON },
});

const deleteWarehouse = ({ id }) => ({
  method: "DELETE",
  url: `/warehouses/${id}`,
});

export const warehouseApi = {
  getWarehouseStocks,
  addWarehouseStocks,
  updateWarehouseStocks,
  deleteWarehouseStocks,
  getWarehouses,
  addWarehouse,
  updateWarehouse,
  deleteWarehouse,
};
